import React from "react";
// Limitless imports
import { useExpertOnboardingContext } from "../expert-onboarding/ExpertOnboardingContext";
import { isFieldEmpty } from "@limitless/common/utils";
const DEFAULT_PROGRESS_STATS = {
  totalQuestions: 0,
  questionsAnswered: 0,
  totalReviews: 0,
  reviewsCompleted: 0,
  totalScore: 0,
  expertScore: 0
};
const DEFAULT_MEMBER_DETAILS = {
  todo: [],
  awaitingVerification: [],
  verified: []
};
export const useExpertOnboardingMetrics = (t = v => v) => {
  var _onboardingDetail$onb, _onboardingDetail$onb2, _onboardingDetail$onb3;
  const {
    onboardingDetail,
    getOnboardingDetail,
    onboardingSummary
  } = useExpertOnboardingContext();
  const [progressStats, setProgressStats] = React.useState(DEFAULT_PROGRESS_STATS);
  const [memberDetails, setMemberDetails] = React.useState(DEFAULT_MEMBER_DETAILS);
  React.useEffect(() => {
    if (!onboardingDetail.loading) {
      getProgressStats();
      getMemberDetails();
    }
  }, [onboardingDetail]);
  const {
    wAppTitle,
    mAppTitle
  } = React.useMemo(() => {
    var _onboarding$nonActive, _onboarding$activePra;
    const {
      onboarding
    } = onboardingDetail;
    if (onboarding !== null && onboarding !== void 0 && (_onboarding$nonActive = onboarding.nonActivePracticeQuestions) !== null && _onboarding$nonActive !== void 0 && _onboarding$nonActive.length || onboarding !== null && onboarding !== void 0 && (_onboarding$activePra = onboarding.activePracticeQuestions) !== null && _onboarding$activePra !== void 0 && _onboarding$activePra.length) {
      const {
        nonActivePracticeQuestions,
        activePracticeQuestions
      } = onboarding;
      const arrayWithResults = activePracticeQuestions.length ? activePracticeQuestions : nonActivePracticeQuestions;
      const firstMessage = arrayWithResults[0];
      return {
        wAppTitle: t("Onboarding ({0})", firstMessage.displayName || firstMessage.groupName),
        mAppTitle: `${firstMessage.displayName || firstMessage.groupName}`
      };
    }
    return {
      wAppTitle: "Onboarding",
      mAppTitle: "Onboarding"
    };
  }, [onboardingDetail]);
  const outcomeState = (_onboardingDetail$onb = onboardingDetail.onboarding) !== null && _onboardingDetail$onb !== void 0 && (_onboardingDetail$onb2 = _onboardingDetail$onb.onboardingOutcomeState) !== null && _onboardingDetail$onb2 !== void 0 && _onboardingDetail$onb2.includes("in_progress_awaiting_decision") ? "in_progress_awaiting_decision" : (_onboardingDetail$onb3 = onboardingDetail.onboarding) === null || _onboardingDetail$onb3 === void 0 ? void 0 : _onboardingDetail$onb3.onboardingOutcomeState;
  const isPromotedOrRejected = outcomeState === "promoted" || outcomeState === "rejected";
  const PROGRESS_STEPS = [{
    stage: "complete",
    text: t("Quizzes")
  }, {
    stage: "complete",
    text: t("Sign Up")
  }, {
    stage: "complete",
    text: t("Complete Profile")
  }, {
    stage: outcomeState ? isPromotedOrRejected ? "complete" : "inProgress" : "complete",
    text: t("Practice Tasks")
  }, {
    stage: outcomeState ? isPromotedOrRejected ? "inProgress" : "toDo" : "complete",
    text: t("Onboarding Complete")
  }];
  const getProgressStats = () => {
    setProgressStats({
      totalQuestions: onboardingDetail.onboarding.practiceQuestionsTotal || 0,
      questionsAnswered: onboardingDetail.onboarding.completedByExpertTotal || 0,
      totalReviews: onboardingDetail.onboarding.completedByExpertTotal || 0,
      reviewsCompleted: onboardingDetail.onboarding.reviewCompletedTotal || 0,
      totalScore: onboardingDetail.onboarding.maxExpectedScore || 0,
      expertScore: onboardingDetail.onboarding.expertScoreTotal || 0
    });
  };
  const getMemberDetails = () => {
    const {
      onboarding: {
        checks
      }
    } = onboardingDetail;
    if (checks) {
      const todo = checks.filter(c => isFieldEmpty(c.value));
      const awaitingVerification = checks.filter(c => c.value && c.verification === null && c.requiresVerification === true);
      const verified = checks.filter(c => {
        if (c.value !== null) {
          if (c.requiresVerification === false) {
            return true;
          } else {
            return c.verification === null ? false : true;
          }
        }
        return false;
      });
      setMemberDetails({
        todo,
        awaitingVerification,
        verified
      });
    }
  };
  const ONBOARDING_STATE_OPTIONS = {
    promoted: {
      text: t("Successful"),
      colour: "green"
    },
    rejected: {
      text: t("Unsuccessful"),
      colour: "red"
    },
    // eslint-disable-next-line camelcase
    in_progress_completing_questions: {
      text: t("Completing Questions"),
      colour: "blue"
    },
    // eslint-disable-next-line camelcase
    in_progress_requires_review: {
      text: t("Requires Review"),
      colour: "blue"
    },
    // eslint-disable-next-line camelcase
    in_progress_awaiting_decision: {
      text: t("Awaiting Decision"),
      colour: "blue"
    }
  };
  const ONBOARDING_STATE = ONBOARDING_STATE_OPTIONS[outcomeState] || false;
  const getNumOfUnreadNotifications = () => {
    const {
      newInvitations,
      practiceGroups
    } = onboardingSummary;
    const inProgressOnboarding = practiceGroups === null || practiceGroups === void 0 ? void 0 : practiceGroups.filter(item => item.membershipState === "active" && (item.onboardingOutcomeState === "in_progress_completing_questions" || (item === null || item === void 0 ? void 0 : item.totalChecks) !== (item === null || item === void 0 ? void 0 : item.completedChecks)));
    return newInvitations.length + inProgressOnboarding.length;
  };
  const refetchOnboardingDetails = () => {
    getOnboardingDetail(onboardingDetail.onboarding);
  };
  return {
    PROGRESS_STEPS,
    ONBOARDING_STATE,
    progressStats,
    onboardingDetail,
    getNumOfUnreadNotifications,
    getOnboardingDetail,
    wAppTitle,
    mAppTitle,
    memberDetails,
    refetchOnboardingDetails,
    getMemberDetails,
    outcomeState
  };
};